import {createAxios} from '../index';

export const investorApiClient = createAxios({baseUrl: process.env.REACT_APP_API_URL});
